
export default function CTA() {
  return (
    <section id="about" className="grid grid-cols-1 lg:grid-cols-2 min-h-[400px] sm:min-h-[600px]">
      {/* Left Panel */}
      <div className="relative overflow-hidden bg-[#F5F1E8] min-h-[300px] sm:min-h-0">
        <img
          src="https://public.readdy.ai/ai/img_res/8e08b30a342a9a1ecd96be5594391aee.jpg"
          alt="Transform Your Business"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
        <div className="absolute top-6 left-6 sm:top-10 sm:left-10">
          <span className="text-xs sm:text-sm font-light text-gray-700 tracking-widest whitespace-nowrap">GET STARTED</span>
        </div>
      </div>

      {/* Right Panel */}
      <div className="bg-white flex items-center justify-center p-8 sm:p-12 lg:p-20">
        <div className="max-w-md text-center">
          <h3 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#1A2332] mb-6 sm:mb-8 leading-tight">
            Ready to<br />Innovate?
          </h3>
          <p className="text-sm sm:text-base text-gray-600 leading-relaxed mb-6 sm:mb-10">
            Let&apos;s discuss how our IT solutions can help your business achieve its digital transformation goals. Our experts are ready to guide you through every step of your journey.
          </p>
        </div>
      </div>
    </section>
  );
}
